import MobileSection from './MobileSection';

export default MobileSection;
